module.exports = __webpack_public_path__ + "static/media/typeA3.b9908dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/hero/typeA3.png
// module id = 1215
// module chunks = 0